<template>
<div class="query-header">
  <el-row
    :gutter="20"
  >
    <el-col
      :lg="8"
      :sm="12"
      :xs="24"
    >
      <div class="label">{{$t('User.reportComiType')}}</div>
      <el-select
        style="width: 100%"
        :placeholder="$t('please_choose')"
        v-model="outType"
        clearable
        @change="toQuery"
      >
        <el-option
          v-for="(item,index) in outTypeList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-col>
    <el-col
      :lg="8"
      :sm="12"
      :xs="24"
    >
      <div class="label">{{$t('Approval_Status')}}</div>
      <el-select
        style="width: 100%"
        :placeholder="$t('please_choose')"
        v-model="status"
        clearable
        @change="toQuery"
      >
        <el-option
          v-for="(item,index) in statusList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-col>
    <el-col
      :lg="8"
      :sm="12"
      :xs="24"
    >
      <div class="label">{{$t('root.time')}}</div>
      <el-date-picker
        v-if="!realMobile"
        style="width: 100%"
        v-model="date"
        @change="toQuery"
        type="daterange"
        value-format="yyyy-MM-dd"
        :range-separator="phFileter('root.dateTo')"
        :start-placeholder="phFileter('root.startDate')"
        :end-placeholder="phFileter('root.endDate')"
      >
      </el-date-picker>
      <select-date-duration
        class="header-sub-item"
        v-model="date"
      ></select-date-duration>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime,init_date } from '@/utils'
export default {
  name: "queryHeader",
  data() {
    return {
      outType: '',
      outTypeList: [
          {
            value:7,
            label:this.$t('User.reportComiType1')
          },
          {
            value:0,
            label:this.$t('User.reportComiType2')
          },
          {
            label: this.$t('The_commission_to_USDT') ,
            value: 8,
          },
          {
            label: this.$t('The_commission_to_OTC365'),
            value: 9,
          },
      ],
      status: '',
      statusList: [
        {label: this.$t('User.reportCommiStatus1'),value: 6},
        {label: this.$t('User.reportCommiStatus2'),value: 7},
        {label: this.$t('User.reportCommiStatus3'),value: 1},
      ],
      date: [], // 时间
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
  },
  methods: {
    phFileter(data){
      return this.$t(data)
    },
    toQuery(){
      this.$emit('toQuery');
    },
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
}
</style>
